import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LayoutModule } from "./layout/layout.module";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LoaderModule } from "./loader/loader.module";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LayoutModule,
    CommonModule,
    LoaderModule,
    HttpClientModule,
    BrowserAnimationsModule,
  ],
  exports: [LoaderModule, LayoutModule],
})
export class CoreModule {}
